/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { createRoot } from 'react-dom/client';
/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import "./editor.scss";
import Reports from "../components/Reports.component";


function mountReportsBlocks() {
	const rootElements = document.querySelectorAll(".root-libraries");

	rootElements.forEach((rootElement) => {
		const year = rootElement.getAttribute("data-year");
		const filterByYearAttr = rootElement.getAttribute("data-filter-by-year");
		const downloadBtnAttr = rootElement.getAttribute("data-download-btn");
		const filterByYear = filterByYearAttr === "1";
		const downloadBtn = downloadBtnAttr === "1";

		if (!rootElement._reportsRoot) {
			const root = createRoot(rootElement);
			root.render(
				<div className="pt-10">
					<div className="block">
						<Reports
							year={year}
							filterByYear={filterByYear}
							downloadBtn={downloadBtn}
						/>
					</div>
				</div>
			);
			rootElement._reportsRoot = root;
		}
	});
}

mountReportsBlocks();



/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {Element} Element to render.
 */
// export default function View() {
// 	const rootElement = document.getElementById("rootLibraries");
// 	const year = rootElement.getAttribute("data-year");
//
// 	return (
// 		<>
// 			<div className="pt-10">
// 					<div className= "block">
// 						<Reports year={year}/>
// 					</div>
// 			</div>
// 		</>
// 	);
// }
//
// const root = createRoot(document.getElementById("rootLibraries"));
// root.render(<View />);
